module.exports = "<div class=\"cookie-popup\">\n  <div class=\"content-wrapper\">\n    <div>Diese Webseite verwendet <a href=\"/privacy\">Cookies</a>.</div>\n    <div class=\"button-wrapper\">\n      <button\n        mz-button\n        class=\"btn-abort btn btn-modal\"\n        (click)=\"declineCookiePolicy()\"\n      >\n        Ablehnen\n      </button>\n      <button mz-button (click)=\"acceptCookiePolicy()\">Akzeptieren</button>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/cookie-popup/cookie-popup.component.html
// module id = ../../../../../src/app/components/cookie-popup/cookie-popup.component.html
// module chunks = main